<template>
  <el-dialog
    v-if="dialogVisible"
    class="create-oracle-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="formData"
      :model="formData"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="名称" prop="OracleID">
        <el-input v-model="formData.OracleID"></el-input>
      </el-form-item>
      <el-form-item label="服务端口" prop="Port">
        <el-input v-model="formData.Port"></el-input>
      </el-form-item>

      <el-form-item label="报警类型" prop="AlarmSenderType">
        <el-select
          v-model="formData.AlarmSenderType"
          placeholder="请选择报警类型"
          class="demo-form-inline"
        >
          <el-option
            v-for="item in AlarmSenderTypeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-if="formData.AlarmSenderType == 'weixin'"
          v-model="formData.AlarmSenderWeixinWebHook"
          title="示例值:ttps://qyapi.weixin.qq.com/cgi-bin/webhook/send?key=f76267ab-d55f1-43e5-97ed-13b4c86f4b0f"
          placeholder="weixin报警地址"
        ></el-input>
        <el-input
          v-if="formData.AlarmSenderType == 'dingding'"
          v-model="formData.AlarmSenderDingdingWebHook"
          title="示例值：https://oapi.dingtalk.com/robot/send?access_token=bc9111e906b80da62d4b4b18b93808c442877cca032f501ef0fc8c92b7780ecc79"
          placeholder="dingding报警地址"
        ></el-input>
        <el-input
          v-if="formData.AlarmSenderType == 'dingding'"
          v-model="formData.AlarmSenderDingdingSecret"
          title="示例值：SEC35dee9db3fdf9835d1e5d2d489c9e74f652fb8213ac694f35bcd16fb0gcc292626"
          placeholder="dingding报警地址密钥"
        ></el-input>
      </el-form-item>

      <el-form-item v-for="(list, index) in formData.data" :key="index" :label="'选择区块链'">
        <el-select
          v-model="list.ChainID"
          placeholder="请选择区块链"
          class="demo-form-inline chain-select"
          @change="chainChange(index)"
        >
          <el-option
            v-for="item in list.chainList"
            :key="item.ChainId"
            :label="item.ChainName"
            :value="item.ChainId"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="list.OrgID"
          placeholder="请选择区组织"
          class="demo-form-inline org-select"
          @change="orgChange(index)"
        >
          <el-option
            v-for="item in list.orgList"
            :key="item.OrgId"
            :label="item.OrgName"
            :value="item.OrgId"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="list.NodeId"
          placeholder="请选择节点"
          class="demo-form-inline node-select"
          @change="nodeChange(index)"
        >
          <el-option
            v-for="item in list.nodeList"
            :key="item.NodeId"
            :label="item.NodeName"
            :value="item.NodeId"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="list.UserName"
          placeholder="请选择用户"
          class="demo-form-inline user-select"
        >
          <el-option
            v-for="item in list.userList"
            :key="item.UserName"
            :label="item.UserName"
            :value="item.UserName"
          >
          </el-option>
        </el-select>

        <el-button
          v-if="formData.data.length > 1"
          class="select-chain-delete-btn"
          @click.prevent="removeDomain(index)"
          >删除</el-button
        >
      </el-form-item>

      <el-form-item style="text-align: right;">
        <el-button class="add-server" @click="addDomain">添加区块链</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleSubmit()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'CreateOracleDialog',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      itemIndex: 0,
      AlarmSenderTypeOption: [
        {
          label: 'dummy（不报警）',
          value: 'dummy'
        },
        {
          label: 'weixin',
          value: 'weixin'
        },
        {
          label: 'dingding',
          value: 'dingding'
        }
      ],
      formData: {
        OracleID: '', //预言机名称
        Port: '', //预言机ip
        AlarmSenderType: '',
        AlarmSenderWeixinWebHook: '',
        AlarmSenderDingdingWebHook: '',
        AlarmSenderDingdingSecret: '',
        data: [
          {
            ChainID: '',
            OrgID: '',
            OrgName: '',
            NodeId: '',
            NodeName: '',
            UserName: '',
            chainList: [],
            orgList: [],
            nodeList: [],
            userList: []
          }
        ]
      },
      userOptions: [], //用户列表
      options: [{ label: 'aa', value: 'bb' }],
      nodeList: [], //节点列表
      title: '创建预言机',
      position: 'right',
      editRule: {
        OracleID: [{ required: true, message: '请输入预言机名称', trigger: 'blur' }],
        Port: [
          { required: true, message: '请输入服务端口', trigger: 'blur' },
          {
            pattern: /^(102[4-9]|10[3-9]\d|[2-9]\d{3,})$/,
            message: '请正确输入端口',
            trigger: 'blur'
          }
        ]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    //创建预言机
    handleSubmit() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          this.disabled = true
          let params = {}
          params.OracleID = this.formData.OracleID
          params.Port = Number(this.formData.Port)
          params.Chains = this.formData.data
          params.AlarmSenderType = 'dummy'
          delete params.Chains.chainList
          delete params.Chains.orgList
          delete params.Chains.nodeList
          delete params.Chains.userList

          params.Chains.map(item => {
            delete item.chainList
            delete item.orgList
            delete item.nodeList
            delete item.userList
            return item
          })

          //获取form数据
          let self = this;
          this.$apis.oracleManagement
            .createOraclet(params)
            .then(res => {
              if (res) {
                self.$message.success('新建预言机成功')
                self.$emit('update:list')
                self.$emit('showDownload', { OracleID: self.formData.OracleID }, true)
                self.dialogVisible = false
                self.disabled = false
              } else {
                self.disabled = false
                self.$message.error(errCode[err.response['data']['errors'][0]['code']])
              }
            })
            .catch(err => {
              self.disabled = false
              self.$message.error(errCode[err.response['data']['errors'][0]['code']])
            })
        } else {
          this.disabled = false
          this.$message.warning('请完善信息')
          return
        }
      })
    },
    addDomain() {
      this.formData.data.push({
        ChainID: '',
        OrgID: '',
        OrgName: '',
        NodeId: '',
        NodeName: '',
        UserName: '',
        chainList: [],
        orgList: [],
        nodeList: [],
        userList: []
      })
      this.itemIndex = this.formData.data.length - 1
      this.getChainList()
    },
    removeDomain(index) {
      this.formData.data.splice(index, 1)
    },
    //获取链列表
    getChainList() {
      let param = {
        offset: 0,
        limit: 50
      }
      let self = this
      this.$apis.home.getSubscribeQueryList(param).then(res => {
        if (res.data && res.data.items) {
          //DPOS共识类型的链，不可在预言机选择
          let items = res.data.items.filter(e => {
            return e.Consensus != 'DPOS'
          })
          self.formData.data[self.itemIndex].chainList = items

          if (items.length === 0) {
            // this.$store.commit('updateLoading', false)
            self.$message.warning('请订阅区块链！')
          }
        }
      })
    },
    //选择链出发change事件获取组织
    async chainChange(index) {
      this.itemIndex = index
      let param = {
        offset: 0,
        limit: 50,
        chainId: this.formData.data[this.itemIndex].ChainID
      }
      await this.$apis.chain.getChainOrgList(param).then(res => {
        if (res.data.items) {
          this.formData.data[this.itemIndex].orgList = res.data.items
        }
      })
    },
    //获取节点
    ...mapActions(['getChainNodeLists']),
    getNodeList(params = {}) {
      params.offset = 0
      params.limit = 100
      params.chainId = this.formData.data[this.itemIndex].ChainID
      params.orgId = this.formData.data[this.itemIndex].OrgID

      this.getChainNodeLists({ ...params }).then(res => {
        if (res.items) {
          this.formData.data[this.itemIndex].nodeList = res.items
        }
      })
    },
    //获取用户
    getUserList() {
      let OrigID = this.formData.data[this.itemIndex].OrgID
      this.$apis.certificate.getUserListByOrg({ OrgId: OrigID }).then(res => {
        if (res.data && res.data.items) {
          this.formData.data[this.itemIndex].userList = res.data.items
        }
      })
    },
    //组织的change事件，赋值orgname
    orgChange(index) {
      this.itemIndex = index

      this.formData.data[this.itemIndex].orgList.map(item => {
        if (item.OrgId === this.formData.data[this.itemIndex].OrgID) {
          this.formData.data[this.itemIndex].OrgName = item.OrgName
        }
      })

      //顺便获取节点
      this.getNodeList()

      this.getUserList()
    },
    //节点的change事件，赋值nodename
    nodeChange(index) {
      this.itemIndex = index
      this.formData.data[this.itemIndex].nodeList.map(item => {
        if (item.NodeId === this.formData.data[this.itemIndex].NodeId) {
          this.formData.data[this.itemIndex].NodeName = item.NodeName
        }
      })
    },
    handleSelect(val) {
      this.orgId = val
    },
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
    },
    handleOpen(chainId) {
      this.formData = {
        OracleID: '', //预言机名称
        Port: '', //预言机ip
        AlarmSenderType: '',
        AlarmSenderWeixinWebHook: '',
        AlarmSenderDingdingWebHook: '',
        AlarmSenderDingdingSecret: '',
        data: [
          {
            ChainID: '',
            OrgID: '',
            OrgName: '',
            NodeId: '',
            NodeName: '',
            UserName: '',
            chainList: [],
            orgList: [],
            nodeList: [],
            userList: []
          }
        ]
      }
      this.itemIndex = 0
      this.getChainList() //默认有一个，获取第一行的链信息
      this.dialogVisible = true
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row)
    },
    formatType(row) {
      return row === 0 ? '共识节点' : '普通节点'
    }
  }
}
</script>

<style scoped lang="scss">
.create-oracle-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;

      .select-chain-delete-btn {
        margin-left: var(--base-size-16);
      }
    }

    .add-server {
      width: 100%;
    }
  }
}
</style>
